import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { RefetchProvider } from "@piiqtechnologies/ui-lib";
import { PeekGrid, PeekStack } from "@piiqtechnologies/ui-components";
import AppHeader from "@components/app-header";
export const AdminAIDiscoverabilityLayout = () => {
    const [layoutConfig, setLayoutConfig] = useState({
        pageTitle: "",
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center" },
                React.createElement(AppHeader, { headerLabel: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.pageTitle }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, { context: { setLayoutConfig } })))));
};
